export const ANCHORS_PARAM_KEY = "anchors[]";
export const PAGE_PARAM_KEY = "p";
export const SORT_PARAM_KEY = "s";
export const FILTERS_PARAM_KEY = "f__";

export const SORT_KEY_RELEVANCE = "relevancia";
